/* eslint-disable react/jsx-fragments */
import React from "react";
import PropTypes from "prop-types";

import Headerbar from "../../headerbar/headerbar";
import GlobalSidebarTemplate from "../globalSidebarTemplate/globalSidebarTemplate";

class GlobalHeaderTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.state = {
      float: {
        direction: "left",
        visible: false,
        toggle: this.toggleSidebar
      }
    };
  }

  toggleSidebar() {
    this.setState(prevState => {
      const { float } = prevState;
      float.visible = !float.visible;
      return { float };
    });
  }

  render() {
    const {
      appDataSet,
      getAppNavMenu,
      getCommonNavMenu,
      globalSidebarEnabled,
      brand,
      mspConfig,
      dataTestId
    } = this.props;

    const {
      productDisplayName,
      globalSidebarContent,
      isFedrampCompliant,
      is_managed_by_insync: isManagedByInsync,
      druvaoneurl,
      oem = {}
    } = appDataSet;

    const { float } = this.state;

    const appNavItems = getAppNavMenu(appDataSet);
    const commonNavItems = getCommonNavMenu(appDataSet);

    // TODO: Need to verify druvaoneurl returned in application data works for Dell and MSP scanerios.
    const consoleConfig = isManagedByInsync
      ? {}
      : {
          href: druvaoneurl,
          isActive: productDisplayName === "Home"
        };

    const { uiCustomizations = {} } = oem;
    const { links = {} } = uiCustomizations;

    return (
      <div data-testid={dataTestId}>
        <Headerbar
          onGlobalMenuClick={this.toggleSidebar}
          isGlobalMenuActive={float.visible}
          onClick={e => {
            const container =
              document.getElementsByClassName("oui-hamburger-icon")[0];
            if (
              container !== e.target &&
              !container.contains(e.target) &&
              float.visible
            ) {
              this.toggleSidebar();
            }
          }}
          brand={brand}
          consoleConfig={consoleConfig}
          mspConfig={mspConfig}
          left={appNavItems}
          right={commonNavItems}
        />
        {globalSidebarEnabled ? (
          <GlobalSidebarTemplate
            float={float}
            productName={productDisplayName}
            globalSidebarContent={globalSidebarContent}
            isFedrampCompliant={isFedrampCompliant}
            footerLinks={links}
          />
        ) : null}
      </div>
    );
  }
}

GlobalHeaderTemplate.propTypes = {
  appDataSet: PropTypes.objectOf(PropTypes.any).isRequired,
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    logoUrl: PropTypes.string,
    renderComponent: PropTypes.func,
    isActive: PropTypes.bool,
    href: PropTypes.string,
    portalName: PropTypes.string
  }).isRequired,
  mspConfig: PropTypes.shape({
    logoUrl: PropTypes.string,
    mspName: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string,
    isActive: PropTypes.bool
  }),
  getAppNavMenu: PropTypes.func,
  getCommonNavMenu: PropTypes.func,
  globalSidebarEnabled: PropTypes.bool,
  dataTestId: PropTypes.string
};

GlobalHeaderTemplate.defaultProps = {
  globalSidebarEnabled: true,
  dataTestId: "orion-globalheader-template"
};

GlobalHeaderTemplate.displayName = "OrionGlobalHeaderTemplate";

export default GlobalHeaderTemplate;
